import { NFTRedeemCalculator } from 'src/utils/NFTRedeemCalculator.ts';

export interface NFT {
    identifier: string;
    collection: string;
    attributes: string;
    media: {
        thumbnailUrl: string;
    }[];
}

export interface NFTList {
    nfts: NFT[];
}

export interface RedeemValues {
    currentPercentage: number;
    currentValue: number;
    oneMonthPercentage: number;
    oneMonthValue: number;
    maxValue: number;
}

export const getNFTRedeemValues = (nft: NFT, currentEpoch: number): RedeemValues => {
    try {
        // console.log('Getting redeem values for NFT:', nft.identifier);
        // console.log('Current epoch:', currentEpoch);

        if (!nft?.attributes) {
            console.error('NFT or attributes missing:', nft);
            return {
                currentPercentage: 0,
                currentValue: 0,
                oneMonthPercentage: 0,
                oneMonthValue: 0,
                maxValue: 0,
            };
        }

        const attrs = NFTRedeemCalculator.parseAttributes(nft.attributes);
        // console.log('Parsed attributes:', attrs);

        const currentValues = NFTRedeemCalculator.calculateRedeemValue({
            currentEpoch,
            startEpoch: attrs.startEpoch,
            finalEpoch: attrs.finalEpoch,
            minPercentage: attrs.minPercentage,
            maxValue: attrs.maxValue,
            n: attrs.powerN,
        });
        // console.log('Current values:', currentValues);

        const oneMonthValues = NFTRedeemCalculator.calculateRedeemValue({
            currentEpoch: currentEpoch + 30,
            startEpoch: attrs.startEpoch,
            finalEpoch: attrs.finalEpoch,
            minPercentage: attrs.minPercentage,
            maxValue: attrs.maxValue,
            n: attrs.powerN,
        });
        // console.log('One month values:', oneMonthValues);

        const result = {
            currentPercentage: currentValues.percentage,
            currentValue: currentValues.actualValue,
            oneMonthPercentage: oneMonthValues.percentage,
            oneMonthValue: oneMonthValues.actualValue,
            maxValue: attrs.maxValue,
        };
        //  console.log('Final result:', result);
        return result;
    } catch (error) {
        console.error('Error calculating NFT values:', error);
        return {
            currentPercentage: 0,
            currentValue: 0,
            oneMonthPercentage: 0,
            oneMonthValue: 0,
            maxValue: 0,
        };
    }
};

export const getNFTFinalEpoch = (nft: NFT): number => {
    const attrs = NFTRedeemCalculator.parseAttributes(nft.attributes);
    return attrs.finalEpoch;
};

export const isNFTRedeemable = (nft: NFT): boolean => {
    try {
        NFTRedeemCalculator.parseAttributes(nft.attributes);
        return true;
    } catch (e) {
        return false;
    }
}; 